import React, { PureComponent } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  getCategoriesByStatus,
  getProducts,
  finishReceiveByStatus,
  saveProduct,
  editProduct,
  finishSubmitProduct,
  getProductById,
  getCategoriesWithOffSetAndLimit,
  showModalProduct,
  deleteProduct,
  sortOrderProduct,
  closeProductModal,
  deleteProductsFromList,
  orderProductItem,
  orderCategoryItem,
  collapseCategory,
  setCollapseAllCategories,
  toggleListProductItem,
  toggleListCategoryItem,
  toggleAllProducts,
  updateProductStatus,
  insertCategoryInProductsList,
  updateProductCategoryName,
} from '../../store/actions';
import { GET_LIMIT, PRODUCT_CORE_ACTIONS, PATHS } from '../../helpers/constants';
import { formatProductsToBeDeleted } from '../../helpers/products';
import { setExportProducts, getExportProducts, clearExportProducts } from '../../helpers/session';

export default function withProducts(WrappedComponent) {
  const mapStateToProps = state => ({
    categories: state.products.categories,
    isLoadingProducts: state.products.isLoading,
    isLoadingSubmitProduct: state.products.isLoadingSubmit,
    isSubmitProductFinished: state.products.finishSubmitProduct,
    finishReceiveProducts: state.products.finishReceiveProducts,
    productRequestError: state.products.error,
    isLoadingProduct: state.products.isLoadingProduct,
    errorLoadingProducts: state.products.errorLoading,
    modalProduct: state.products.modalProduct,
    qttyProductsSelected: state.products.qttyProductsSelected,
  });

  const mapDispatchToProps = dispatch => ({
    getAllProductsByStatus: (status, extended) => dispatch(getCategoriesByStatus(status, extended)),
    getProducts: (categories, exportProducts) => dispatch(getProducts(categories, exportProducts)),
    saveProduct: data => dispatch(saveProduct(data)),
    editProduct: (id, data) => dispatch(editProduct(id, data)),
    finishSubmitProduct: () => dispatch(finishSubmitProduct()),
    finishReceiveByStatus: () => dispatch(finishReceiveByStatus()),
    getProductById: id => dispatch(getProductById(id)),
    getCategoriesWithOffSetAndLimit: (offset, limit = GET_LIMIT) =>
      dispatch(getCategoriesWithOffSetAndLimit(offset, limit)),
    showModalProduct: (type, data) => dispatch(showModalProduct(type, data)),
    closeProductModal: () => dispatch(closeProductModal()),
    deleteProduct: data => dispatch(deleteProduct(data)),
    deleteProductsFromList: data => dispatch(deleteProductsFromList(data)),
    sortOrderProduct: data => dispatch(sortOrderProduct(data)),
    orderProductItem: (categoryId, currPos, newPos) =>
      dispatch(orderProductItem(categoryId, currPos, newPos)),
    orderCategoryItem: (currPos, newPos) => dispatch(orderCategoryItem(currPos, newPos)),
    collapseCategory: id => dispatch(collapseCategory(id)),
    setCollapseAllCategories: collapse => dispatch(setCollapseAllCategories(collapse)),
    toggleListProductItem: (categoryId, productId) =>
      dispatch(toggleListProductItem(categoryId, productId)),
    toggleListCategoryItem: categoryId => dispatch(toggleListCategoryItem(categoryId)),
    toggleAllProducts: () => dispatch(toggleAllProducts()),
    updateProductStatus: (productId, data) => dispatch(updateProductStatus(productId, data)),
    insertCategoryInProductsList: category => dispatch(insertCategoryInProductsList(category)),
    updateProductCategoryName: (idCategory, name) =>
      dispatch(updateProductCategoryName(idCategory, name)),
  });

  /* eslint-disable react/prop-types */
  class ProductContainer extends PureComponent {
    onClickProductActions = (type, data) => {
      const { showModalProduct, history } = this.props;
      switch (type) {
        case PRODUCT_CORE_ACTIONS.EXPORT:
          showModalProduct(type, this.prepareExportData());
          break;
        case PRODUCT_CORE_ACTIONS.DELETE:
          showModalProduct(type, data || this.prepareDeleteData());
          break;
        case PRODUCT_CORE_ACTIONS.EDIT:
          const path = PATHS.editProduct.replace(':id', data);
          history.push(path);
          break;
        case PRODUCT_CORE_ACTIONS.CHANGE_STATUS:
          showModalProduct(type, data);
          break;
        default:
          break;
      }
    };

    refreshProductsList = success => {
      const { closeProductModal, deleteProductsFromList, modalProduct } = this.props;
      if (success) {
        deleteProductsFromList(formatProductsToBeDeleted(modalProduct.data));
      }
      closeProductModal();
    };

    productAction = (type, product) => {
      if (type === PRODUCT_CORE_ACTIONS.DELETE) {
        this.onClickProductActions(PRODUCT_CORE_ACTIONS.DELETE, { product });
      } else if (type === PRODUCT_CORE_ACTIONS.CHANGE_STATUS) {
        this.onClickProductActions(PRODUCT_CORE_ACTIONS.CHANGE_STATUS, {
          product,
        });
      }
    };

    isProductModal = type => {
      const { modalProduct } = this.props;
      return modalProduct.type === type;
    };

    getProductsQttySelected = () => {
      let count = 0;
      this.props.categories.forEach(cat => {
        if (cat.checked) {
          count = count + cat.products.length;
        } else {
          count = count + cat.products.filter(prod => prod.checked).length;
        }
      });
    };
    /* eslint-disable array-callback-return */
    prepareExportData() {
      let categoriesExport = [];
      let categoryExport = {};
      const menuItems = [];

      this.props.categories.map(category => {
        if (category.products.some(p => p.checked)) {
          categoryExport = {
            ...category,
            checked: true,
            products: [],
          };
        }
        if (category.checked) {
          category.products.map(prod => {
            if (prod.status === 1) {
              menuItems.push({ productId: prod.id, price: prod.originalPrice });
              categoryExport.products.push(prod);
            }
          });
        } else {
          category.products.map(prod => {
            if (prod.checked) {
              menuItems.push({ productId: prod.id, price: prod.originalPrice });
              categoryExport.products.push(prod);
            }
          });
        }

        if (categoryExport && JSON.stringify(categoryExport) !== '{}') {
          categoriesExport.push(categoryExport);
          categoryExport = {};
        }
      });

      if (categoriesExport.length) {
        setExportProducts(categoriesExport);
      } else {
        if (getExportProducts().categories) {
          clearExportProducts();
        }
      }

      return { menuItems };
    }

    prepareDeleteData() {
      const categories = [];
      const products = [];
      const productInCategory = [];

      this.props.categories.map(category => {
        if (category.checked) {
          categories.push(category.id);
        } else {
          category.products.map(prod => {
            if (prod.checked) {
              if (products.length) {
                products.map((item, i) => {
                  if (item.categoryId === category.id) {
                    products[i].products.push(prod.id);
                  } else if (!products.some(p => p.categoryId === category.id)) {
                    /* item.categoryId = category.id; */
                    products.push({
                      categoryId: category.id,
                      products: [prod.id],
                    });
                  }
                });
              } else {
                productInCategory.push(prod.id);
                products.push({
                  categoryId: category.id,
                  products: productInCategory,
                });
              }
            }
          });
        }
      });

      return { categories, products };
    }
    /* eslint-enable array-callback-return */

    render() {
      return (
        <WrappedComponent
          onClickProductActions={this.onClickProductActions}
          isProductModal={this.isProductModal}
          productAction={this.productAction}
          getProductsQttySelected={this.getProductsQttySelected}
          refreshProductsList={this.refreshProductsList}
          {...this.props}
        />
      );
    }
  }
  /* eslint-enable */

  const ProductModals = connect(
    mapStateToProps,
    mapDispatchToProps
  )(ProductContainer);

  return compose(withRouter)(ProductModals);
}



// WEBPACK FOOTER //
// ./src/containers/Products/index.js